import state from './questionState';
import mutations from './questionMutations';
import getters from './questionGetters';
import actions from './questionActions';

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
